export default __webpack_public_path__ + "static/media/chat-bubble-outline.6f1bb890.svg";